// extracted by mini-css-extract-plugin
export default {"RoleFormRoot":"RoleFormRoot---FCIwh","alignRightWrapper":"alignRightWrapper---EV0Sx"};